export default __webpack_public_path__ + "static/media/logo.fea6b95a.png";